import styles from "./OverviewSubTab.module.scss"

import { getJstDate } from "@/utils/jst_date"

type Props = {
	souhlUnpaidAmount: number
	companyUnpaidAmount: number
	unpaidUntil: { year: number; month: number } | null
}

const formatUnpaidUntil = (
	unpaidUntil: { year: number; month: number } | null
): string | null => {
	if (!unpaidUntil) return null
	const lastDay = getJstDate(new Date(unpaidUntil.year, unpaidUntil.month, 0))
	return `${unpaidUntil.year}年${unpaidUntil.month}月${lastDay}日までの成果分`
}

const UnpaidAmountsSection = ({
	souhlUnpaidAmount,
	companyUnpaidAmount,
	unpaidUntil,
}: Props) => {
	const periodLabel = formatUnpaidUntil(unpaidUntil)

	return (
		<div className={styles.section}>
			<h3 className={styles.section_title}>SOUHL 未振込 / 御社 未払い金額</h3>
			<div className={styles.amount_cards}>
				<div className={styles.amount_card}>
					<span className={styles.amount_card_label}>
						SOUHL 未振込金額
						{periodLabel && (
							<span className={styles.amount_card_period}>
								（{periodLabel}）
							</span>
						)}
					</span>
					<span className={styles.amount_card_value}>
						&yen;{souhlUnpaidAmount.toLocaleString()}
					</span>
				</div>
				<div className={styles.amount_card}>
					<span className={styles.amount_card_label}>
						御社 未払い金額
						{periodLabel && (
							<span className={styles.amount_card_period}>
								（{periodLabel}）
							</span>
						)}
					</span>
					<span className={styles.amount_card_value}>
						&yen;{companyUnpaidAmount.toLocaleString()}
					</span>
				</div>
			</div>
		</div>
	)
}

export default UnpaidAmountsSection
